import { create } from 'zustand'

type TMemberListStore = {
  searchValue: string
  setSearchValue: (value: string) => void
  resetSearchValue: () => void
}

export const useGlobalMemberListStore = create<TMemberListStore>()(set => ({
  searchValue: '',
  setSearchValue: searchValue => set({ searchValue }),
  resetSearchValue: () => set({ searchValue: '' })
}))
